import React, { useState, useEffect } from "react";
import apiService from "../services/api";
import "../styles/Achievements.css";

const Achievements = ({ sidebarOpen }) => {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAchievements = async () => {
      try {
        console.log('🏆 Loading achievements...');
        const achievementsResponse = await apiService.getAchievements();
        console.log('🏆 Achievements response:', achievementsResponse);
        console.log('🏆 Achievements array:', achievementsResponse.achievements);
        console.log('🏆 Earned achievements:', achievementsResponse.achievements.filter(a => a.isEarned));
        setAchievements(achievementsResponse.achievements);
      } catch (error) {
        console.error('Failed to load achievements:', error);
      }
      setLoading(false);
    };

    loadAchievements();
  }, []);


  const earnedCount = achievements.filter(a => a.isEarned).length;
  const platinumCount = achievements.filter(a => a.isEarned && a.tier === 'platinum').length;
  const goldCount = achievements.filter(a => a.isEarned && a.tier === 'gold').length;
  const silverCount = achievements.filter(a => a.isEarned && a.tier === 'silver').length;
  const bronzeCount = achievements.filter(a => a.isEarned && a.tier === 'bronze').length;

  if (loading) {
    return (
      <div className={`achievements-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="loading">Loading achievements...</div>
      </div>
    );
  }

  return (
    <div className={`achievements-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
      {/* Header */}
      <div className="achievements-header">
        <h1 className="achievements-title">
          <span>🏆</span>
          Achievements
        </h1>
        <p className="achievements-subtitle">Track your cooking progress and unlock new badges</p>
      </div>

      {/* Stats Overview */}
      <div className="stats-overview">
        <div className="stat-card">
          <div className="stat-number green">{earnedCount}</div>
          <div className="stat-label">Achievements Unlocked</div>
        </div>
        <div className="stat-card">
          <div className="stat-number platinum">{platinumCount}</div>
          <div className="stat-label">Platinum Badges</div>
        </div>
        <div className="stat-card">
          <div className="stat-number gold">{goldCount}</div>
          <div className="stat-label">Gold Badges</div>
        </div>
        <div className="stat-card">
          <div className="stat-number silver">{silverCount}</div>
          <div className="stat-label">Silver Badges</div>
        </div>
        <div className="stat-card">
          <div className="stat-number bronze">{bronzeCount}</div>
          <div className="stat-label">Bronze Badges</div>
        </div>
      </div>



      {/* All Available Achievements */}
      <div className="all-achievements">
        <h2 className="section-title">🎯 All Achievements</h2>
        <p className="section-subtitle">Complete these challenges to unlock new achievements!</p>
        <div className="achievements-grid">
          {achievements.map((achievement, index) => (
            <div key={index} className={`achievement-card ${achievement.isEarned ? 'unlocked' : 'locked'}`}>
              <div className="achievement-header">
                <div className={`achievement-icon ${achievement.isEarned ? 
                  (achievement.tier || 'bronze') : 'locked'}`}>
                  {achievement.icon}
                </div>
                <div className="achievement-info">
                  <h3>{achievement.name}</h3>
                  <p>{achievement.description}</p>
                </div>
              </div>
              {achievement.isEarned ? (
                <div className="achievement-reward">
                  <span>✅ Earned • +{achievement.pointsReward} points</span>
                </div>
              ) : (
                <div className="achievement-progress">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: '0%' }}></div>
                  </div>
                  <div className="progress-text">Not yet earned</div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Achievements;
